export default "__VITE_ASSET__hN1QOSQ6__"